import React from "react";
import { ConnectionLineComponentProps, InternalNode } from "@xyflow/react";
import { OwnershipFlowNode } from "../ownership.types";
import { CardBounds, getCardBorderPoint } from "./ownershipConnection.helpers";
import styles from "./OwnershipConnectionLine.module.scss";

function cardBoundsFromNode(
    node: InternalNode<OwnershipFlowNode>,
): CardBounds | null {
    const { x, y } = node.internals.positionAbsolute;
    const width = node.measured.width;
    const height = node.measured.height;
    if (width == null || height == null) {
        return null;
    }
    return { x, y, width, height };
}

export const OwnershipConnectionLine: React.FC<
    ConnectionLineComponentProps<OwnershipFlowNode>
> = ({ fromX, fromY, toX, toY, toNode }) => {
    const from = { x: fromX, y: fromY };
    const card = toNode ? cardBoundsFromNode(toNode) : null;
    const end = (card ? getCardBorderPoint(from, card) : null) ?? {
        x: toX,
        y: toY,
    };
    return (
        <path
            className={styles.connectionLine}
            d={`M${from.x},${from.y} L${end.x},${end.y}`}
            fill="none"
        />
    );
};
